module.exports = __webpack_public_path__ + "static/media/unmute.6fb241db.svg";